<div [@casePracticeTeamAuthAnimation] id="wrap" (click)="screenClick()">

  <div [@noticeAnimation]="noticeShow ? 'showNotice' : 'hideNotice'" id="nextStep">
    <img src="{{assetsRoute}}/picture/casepracticepando/click.png" alt="" id="clickIcon">
    <div id="nextStepText" class="fontSize18">
      <span class="textVerticalCenter">点击屏幕任意处可以进行下一步操作</span>
    </div>
  </div>

  <div [@posterAnimation]="posterShow ? 'showPoster' : 'hidePoster'">
    <img src="{{assetsRoute}}/picture/casepracticeinfluence/poster.png" alt="" id="poster">
    <img src="{{assetsRoute}}/picture/casepracticeinfluence/glass.png" alt="" id="glass">
  </div>

  <div [@dialogueAnimation]="dialogueShow ? 'showDiag' : 'hideDiag'">
    <div id="dialogue1" class="fontSize16 lineHeight27">
        什么?!这也没货，那也没货？没货你们在APP上卖什么限时抵扣券！
    </div>

    <div id="dialogue2" class="fontSize16 lineHeight27">
        说什么“现场下单，半小时送到家”？都三小时了，我买的东西呢？
    </div>
    <img src="{{assetsRoute}}/picture/casepracticeinfluence/3.png" alt="" id="dialogue3">
    <img src="{{assetsRoute}}/picture/casepracticeinfluence/4.png" alt="" id="dialogue4">
    <img src="{{assetsRoute}}/picture/casepracticeinfluence/5.png" alt="" id="dialogue5">
    <img src="{{assetsRoute}}/picture/casepracticeinfluence/6.png" alt="" id="dialogue6">
  </div>

  <div id="sideTip" [@sideTipAnimation]="sideTipShow ? 'showSideTip': 'hideSideTip'" class="fontSize14">
    {{sideTipContent}}
  </div>

  <img src="{{assetsRoute}}/picture/casepracticeinfluence/card.png" [@cardAnimation]="cardShow ? 'showCard':'hideCard'" alt="" id="card">

  <div id="findbg" [@problemAnimation]="problemShow ? 'showProblem': 'hideProblem'">
    <img src="{{assetsRoute}}/picture/casepracticeinfluence/problem.png" alt="" id="problem">
    <div id="findBtn" class="fontSize18"  (click)="goToMain()">
      找秦飞
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/case-practice-influence-begin/case-practice-influence-begin.component.html